// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, ActivityNotesDialogStore, CadenceListStore, LeadListStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, getLeadEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Icon from 'src/features/common/CustomIcon';
import MenuItem from '@mui/material/MenuItem';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import IconButton from '@mui/material/IconButton';
import NoteIcon from '@mui/icons-material/Note';
import FormControl from '@mui/material/FormControl';
import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import StandardSkeleton from '../../common/StandardSkeleton';

type Props = {
    leadId: string
    onClose: ()=> void
}

const AddLeadToCadence = ({leadId, onClose} : Props) => {
    const cadenceRecord = CadenceListStore.useState(s => s.record);
    const [cadenceValue, setCadenceValue] = useState<string>('')
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchCadences = async () => {
            setHasLoaded(false);
            const response = await client.get(leadEndpoints.getplaybookcadencelist.replace('{leadid}', "" + leadId));
            CadenceListStore.update(s => { s.record = response.data });
            setCadenceValue(response.data.playbookCadences[0].cadenceId)
            setHasLoaded(true);
        }
        if (leadId != '') fetchCadences();
    }, [leadId])

    const onCancelCadence = () => {
        onClose()
    };
        
    const handleChange = (event: SelectChangeEvent) => {
        setCadenceValue(event.target.value as string);
    };

    
    const onSubmit = async () => {
        await client.post(leadEndpoints.updateleadcadence.replace('{leadid}/{cadenceId}', leadId + "/" + cadenceValue))
            .then(async (response) => {

                const updatedLeadResposne = await client.get(getLeadEndpoint.replace("{id}", leadId));

                LeadListStore.update(s => {
                    const list = _.cloneDeep(s.list);
                    const leadIndex = list.items.findIndex(s => s.id == leadId);
                    const existingLead = list.items[leadIndex];
                    list.items[leadIndex] = { ...existingLead, ...updatedLeadResposne.data };
                    s.list = list;
                });

                onClose()

            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
    }

    if (hasLoaded) {
        return (
            <Box>
                <Grid container>
                    <Grid item xs={12} md={10} alignContent='left' justifyContent={'left'} sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <FormControl >
                            <InputLabel id="-label">Select Cadence</InputLabel>
                            <Select
                                label="Select Cadence"
                                size="small"
                                fullWidth
                                onChange={handleChange}
                                value={cadenceValue}

                            >
                                {cadenceRecord.playbookCadences.map(record => (
                                    <MenuItem
                                        key={record.cadenceId}
                                        value={record.cadenceId}
                                    >
                                        <Grid container spacing={2} justifyContent={'center'} >
                                            <Grid item xs={12} md={12} justifyContent={'left'} alignItems="left">
                                                <Tooltip title={'Type:' + record.cadenceType + ' - Activity: ' + record.activityName + ' - Start Stage:' + record.startStageName} key={record.cadenceId} >
                                                    <Typography variant="inherit" noWrap align="left">
                                                        {record.cadenceName}
                                                    </Typography>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl >
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Tooltip title="Cancel" >
                            <IconButton onClick={onCancelCadence} >
                                <CancelTwoToneIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Tooltip title="Save" >
                            <IconButton onClick={onSubmit} >
                                <CheckCircleOutlineTwoToneIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>

            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }
        
    }
    



export { AddLeadToCadence }

export default AddLeadToCadence;